export default "__VITE_ASSET__BZ5U2Kr8__"